export default "__VITE_ASSET__CO_GYxoq__"